module.exports = __webpack_public_path__ + "img/ups.d1a10f82.svg";